import {TASKMANAGE} from 'Constants/ActionTypes';

//获取项目下拉列表
const actions={
  //设置任务id
  setMonitoringId(id){
    return{
      type: TASKMANAGE.SET_MONITORING_ID,
      payload:{
        id:id
      }
    }
  },
  // 获取项目列表
  getTasksListAll() {
    return {
      type: TASKMANAGE.GET_TASK_LIST_ALL,
      payload: {
        request: {
          method: "post",
          url:`/robot/task/search2`,
        }
      }
    };
  },
  //回调监控
  postCallbackByProId(data) {
    return {
      type: TASKMANAGE.POST_TASK_MONITORING,
      payload: {
        request: {
          method: "post",
          url: `/robot/task/monitor`,
          data: data
        }
      }
    };
  },
}
export default actions;